

import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth';

const LogoutButton = ({ isOpen, onClose, onConfirm }) => {
  const navigate = useNavigate();
  const { logout } = useAuth(); 

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('Userpreference');
    localStorage.removeItem('UIComponents');
    localStorage.removeItem('user');
    if (logout) logout(); 
    if (onConfirm) onConfirm(); 
    navigate('/');
  };

  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3>Are you sure you want to logout?</h3>
        <div style={styles.buttons}>
          <button onClick={handleLogout} style={styles.logoutButton}>
            Logout
          </button>
          <button onClick={onClose} style={styles.cancelButton}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
    minWidth: '300px',
  },
  buttons: {
    marginTop: '1.5rem',
    display: 'flex',
    justifyContent: 'space-around',
  },
  logoutButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  cancelButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#6c757d',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};

export default LogoutButton;

// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import useAuth from './useAuth';
// import './Login.css';
// import axios from 'axios';

// const LogoutButton = ({ isOpen, onClose, onConfirm }) => {
//   const navigate = useNavigate();
//   const { logout } = useAuth();
//   const accessToken = localStorage.getItem('accessToken');

//   const sendManualLogout = async () => {
//     try {
//       const user = JSON.parse(localStorage.getItem('user'));
//       if (!user) return;

//       await axios.post(
//         'https://salesjet-10097049716.catalystappsail.com/agentactive',
//         {
//           userId: user.userId,
//           email: user.email,
//           UserFirstName: user.firstName,
//           Status: "logout",
//           Message: "Manual logout by User",
//           logtimestamp: new Date().toISOString()
//         },
//         {
//           headers: { Authorization: `Bearer ${accessToken}` }
//         }
//       );
//       console.log("Manual logout activity logged.");
//     } catch (error) {
//       console.error("Error logging manual logout:", error.response?.data || error.message);
//     }
//   };
//   const handleLogout = async () => {
//     await sendManualLogout(); 
//     localStorage.removeItem('accessToken');
//     localStorage.removeItem('refreshToken');
//     if (logout) logout();
//     if (onConfirm) onConfirm();
//     navigate('/');
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="logout-overlay">
//       <div className="logout-modal">
//         <h3 style={{color:'#333'}}>Are you sure you want to logout?</h3>
//         <div className="logout-buttons">
//           <button onClick={handleLogout} className="logout-btn-confirm">Logout</button>
//           <button onClick={onClose} className="logout-btn-cancel">Cancel</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LogoutButton;
